module.exports = __webpack_public_path__ + "static/media/pasajeros_transportados.211aff09.svg";